import React, { useCallback, useEffect, useRef } from 'react';
import { SdfMenuItem } from '@waypoint/react-components';
import { MDFIcon } from './MDFIcon';
import { ENTER, isKeyCode, NUMPAD_ENTER, SPACE } from '@waypoint/web-components/tools/a11y/key-codes';

export interface IActionLink2Props {
  children?: React.ReactNode;
  className?: string;
  data?: any;
  disabled?: boolean;
  focused?: boolean;
  iconClass?: string; // From ActionMenuOption
  id?: string;
  text?: string; // From MDFActionMenuOption
  onClick?: (event) => void;
}

export const ActionLink2 = ({
  children,
  className,
  data,
  disabled,
  focused,
  iconClass,
  id,
  text,
  onClick,
  ...additionalProps
}: IActionLink2Props) => {
  const handleClick = useCallback((event: any) => {
    onClick?.(event);
  }, [onClick]);

  const handleKeyUp = useCallback((event: any) => {
    if (isKeyCode(event, SPACE) || isKeyCode(event, ENTER) || isKeyCode(event, NUMPAD_ENTER)) {
      event.preventDefault();
      handleClick(event);
    }
  }, [handleClick]);

  const menuItemRef = useRef(null);

  const itemProps: any = {
    disabled: disabled ? disabled : undefined
  };

  useEffect(() => {
    menuItemRef.current?.addEventListener('click', handleClick);
    menuItemRef.current?.addEventListener('keyup', handleKeyUp);
  }, []);

  if (id) {
    itemProps.id = id;
  }

  if (data) {
    itemProps.data = data;
  }

  if (className) {
    console.error('ActionLink2(): Do not attempt to override the menu item styles. This property is now ignored.');
  }

  if (focused) {
    console.error('ActionLink2(): The component no longer needs/uses the "focused" property.');
  }

  if (onClick) {
    console.error('ActionLink2(): Do not put click handlers on action menu items. Set the "data" property to identify the item and then listen to the sdfChange event on the parent menu instead.');
  }

  if (additionalProps && Object.keys(additionalProps).length > 0) {
    console.error('ActionLink2(): The component does not support these properties:', Object.keys(additionalProps));
  }

  return (
    <SdfMenuItem {...itemProps} ref={menuItemRef}>
      {iconClass && <span slot="before"><MDFIcon className={iconClass} /></span>}
      {text ?? children}
    </SdfMenuItem>
  );
};

ActionLink2.displayName = 'ActionLink2';
